<template>
  <div class="wrap1 wrap1-content">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
      <el-tab-pane :label="$t('certificate_module_2')" name="currency" />
      <el-tab-pane :label="$t('certificate_module_3')" name="official" />
      <el-tab-pane :label="$t('certificate_module_4')" name="staff" />
    </el-tabs>
    <div ref="config" class="config" @scroll="handleScroll">
      <!-- 通用配置 -->
      <el-form :model="currencyData" :rules="currencyRules" ref="currencyForm" class="currency">
        <h2>{{ $t('certificate_module_2') }}</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="company_logo" class="baseinfo-wrap" :label="$t('certificate_module_7')">
              <div class="baseinfo-logo">
                <upload
                  ref="upload"
                  class="upload"
                  listType="picture"
                  :file-limit="1"
                  :show-btn="false"
                  :show-file="false"
                  :multiple="false"
                  :file-format="fileFormat"
                  @success="uploadInfo => uploadSuccess(uploadInfo, currencyData, 'company_logo')"
                />
                <el-image
                  style="width: 100%"
                  :src="currencyData.company_logo"
                  v-if="currencyData.company_logo"
                  :preview-src-list="[currencyData.company_logo]"
                />
                <div v-else class="img">
                  <img src="@/assets/img/icon_logo.png" alt="" />
                </div>
                <i class="close el-icon-circle-close" @click="handleClose(currencyData, 'company_logo')"></i>
                <p class="bottom-tip">{{ $t('313') }}</p>
              </div>
              <div class="baseinfo-name">
                <p class="label-name">{{ $t('certificate_module_17') }}</p>
              </div>
            </el-form-item>
            <!-- 企业名称泰 -->
            <el-form-item prop="c_name_th" :label="$t('1885')">
              <el-input v-model="currencyData.c_name_th" :placeholder="$t('90')"></el-input>
            </el-form-item>
            <!-- 公司地址（英） -->
            <el-form-item prop="address_en" :label="$t('i18n.645bc12941a24d4a9f4c4579d71b13a9')">
              <el-input disabled v-model="currencyData.address_en"></el-input>
            </el-form-item>
          </el-col>
          <!-- 企业签章 -->
          <el-col :span="12">
            <el-form-item prop="c_sign" :label="$t('1903')">
              <div class="baseinfo-logo">
                <upload
                  ref="upload"
                  class="upload"
                  listType="picture"
                  :file-limit="1"
                  :show-btn="false"
                  :show-file="false"
                  :multiple="false"
                  :file-format="fileFormat"
                  @success="uploadInfo => uploadSuccess(uploadInfo, currencyData, 'c_sign')"
                />
                <el-image
                  style="width: 100%"
                  :src="currencyData.c_sign"
                  v-if="currencyData.c_sign"
                  :preview-src-list="[currencyData.c_sign]"
                />
                <div v-else class="img">
                  <img src="@/assets/img/icon_logo.png" alt="" />
                </div>
                <i class="close el-icon-circle-close" @click="handleClose(currencyData, 'c_sign')"></i>
                <p class="bottom-tip">{{ $t('313') }}</p>
              </div>
            </el-form-item>
            <el-form-item prop="address" :label="$t('i18n.91b2c0ab74df4412b99cb4ab32279f57')">
              <el-input disabled v-model="currencyData.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <el-button size="small" type="primary" @click="saveCurrency" v-if="$p('menu.certificate.mould.edit')">{{
            $t('67')
          }}</el-button>
        </div>
      </el-form>
      <!-- 官方文件配置 -->
      <el-form :model="officialData" :rules="officialRules" ref="officialForm" class="item-form">
        <div class="official" ref="official">
          <h2>{{ $t('certificate_module_3') }}</h2>
          <el-row>
            <el-col :span="12">
              <!-- CEO或受委托人 -->
              <el-form-item prop="trustee_staff_id" :label="$t('certificate_module_9')">
                <staff-search @change="v => trusteeStaff(v)" ref="trusteeStaff" comment="comment"></staff-search>
              </el-form-item>
              <!-- CEO或受委托人电子签名 -->
              <el-form-item prop="trustee_sign" :label="$t('certificate_module_8')">
                <div class="baseinfo-logo">
                  <upload
                    ref="upload"
                    class="upload"
                    listType="picture"
                    :file-limit="1"
                    :show-btn="false"
                    :show-file="false"
                    :multiple="false"
                    :file-format="fileFormat"
                    @success="uploadInfo => uploadSuccess(uploadInfo, officialData, 'trustee_sign')"
                  />
                  <el-image
                    style="width: 100%"
                    :src="officialData.trustee_sign"
                    v-if="officialData.trustee_sign"
                    :preview-src-list="[officialData.trustee_sign]"
                  />
                  <div v-else class="img">
                    <img src="@/assets/img/icon_logo.png" alt="" />
                  </div>
                  <i class="close el-icon-circle-close" @click="handleClose(officialData, 'trustee_sign')"></i>
                  <p class="bottom-tip">{{ $t('313') }}</p>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="job_ceo" :label="$t('24')">
                <el-input v-model="form.job_ceo" disabled></el-input> </el-form-item
            ></el-col>
          </el-row>
          <div>
            <el-button size="small" type="primary" @click="saveOfficial" v-if="$p('menu.certificate.mould.edit')">{{
              $t('67')
            }}</el-button>
          </div>
        </div>
      </el-form>
      <!-- 员工证明配置 -->
      <el-form :model="staffData" :rules="staffRules" ref="staffForm" class="item-form">
        <div class="staff" ref="staff">
          <h2>{{ $t('certificate_module_4') }}</h2>
          <el-row>
            <el-col :span="12">
              <!-- 是否允许员工App申请 -->
              <el-form-item prop="is_apply" :label="$t('i18n.Ntyavz1i7eBO')">
                <el-select v-model="staffData.is_apply" :placeholder="$t('221')" clearable @change="handleApply">
                  <el-option :label="$t('532')" value="1"> </el-option>
                  <el-option :label="$t('578')" value="2"> </el-option>
                </el-select>
              </el-form-item>
              <!-- 发送语言 -->
              <el-form-item prop="send_language" :label="$t('certificate_module_11')">
                <el-select
                  v-model="staffData.send_language"
                  :placeholder="$t('221')"
                  clearable
                  multiple
                  @change="sendLanguage"
                >
                  <el-option :label="$t('TH')" value="th"> </el-option>
                  <el-option :label="$t('EN')" value="en"> </el-option>
                </el-select>
              </el-form-item>
              <!-- 企业简称泰 -->
              <el-form-item prop="c_short_name_th" :label="$t('1891')">
                <template slot="label">
                  <span>{{ $t('1891') }}</span>
                  <!-- 文件编码规范 -->
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      <p>{{ $t('1910') }}</p>
                      <p>{{ $t('1911') }}</p>
                      <p>{{ $t('1912') }}</p>
                      <p>{{ $t('1913') }}</p>
                      <br />
                      <p>{{ $t('1914') }}</p>
                    </div>
                    <el-button style="display: inline-block; margin-left: 20px" type="text" size="mini">
                      {{ $t('1915') }}</el-button
                    >
                  </el-tooltip>
                </template>
                <el-input v-model="staffData.c_short_name_th"></el-input>
              </el-form-item>
              <!-- 泰语标识 -->
              <el-form-item prop="th_language" :label="$t('1893')">
                <el-input v-model="staffData.th_language"></el-input>
              </el-form-item>
              <!-- 日期格式 -->
              <el-form-item prop="date_format" :label="$t('1895')">
                <el-select v-model="staffData.date_format" :placeholder="$t('221')" clearable>
                  <el-option :label="$t('1896')" :value="1"> </el-option>
                  <el-option :label="$t('1897')" :value="2"> </el-option>
                </el-select>
              </el-form-item>
              <!-- 负责人 -->
              <el-form-item prop="sign_staff_id" :label="$t('1899')">
                <staff-search @change="v => staffChange(v)" ref="staffSearch" comment="comment"></staff-search>
              </el-form-item>
              <!-- 职位负责人 -->
              <el-form-item prop="job" :label="$t('1901')">
                <el-input v-model="form.job" disabled></el-input>
              </el-form-item>
              <!-- 负责人电子签名 -->
              <el-form-item prop="sign" :label="$t('1898')">
                <!-- upload -->
                <div class="baseinfo-logo">
                  <upload
                    ref="upload"
                    class="upload"
                    listType="picture"
                    :file-limit="1"
                    :show-btn="false"
                    :show-file="false"
                    :multiple="false"
                    :file-format="fileFormat"
                    @success="uploadInfo => uploadSuccess(uploadInfo, staffData, 'sign')"
                  />
                  <el-image
                    style="width: 100%"
                    :src="staffData.sign"
                    v-if="staffData.sign"
                    :preview-src-list="[staffData.sign]"
                  />
                  <div v-else class="img">
                    <img src="@/assets/img/icon_logo.png" alt="" />
                  </div>
                  <i class="close el-icon-circle-close" @click="handleClose(staffData, 'sign')"></i>
                  <p class="bottom-tip">{{ $t('313') }}</p>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 可申请的员工类型 -->
              <el-form-item prop="staff_formal" ref="staffFormal" :label="$t('1887')">
                <el-select
                  v-model="staffData.staff_formal"
                  :placeholder="$t('221')"
                  :disabled="staffData.is_apply === '2'"
                  clearable
                  multiple
                >
                  <el-option :label="$t('1888')" :value="1"> </el-option>
                  <el-option :label="$t('1889')" :value="2"> </el-option>
                </el-select>
              </el-form-item>
              <!-- 企业名称英 -->
              <el-form-item prop="c_name_en" ref="nameEn" :label="$t('1886')">
                <el-input v-model="staffData.c_name_en"></el-input>
              </el-form-item>
              <!-- 企业简称英 -->
              <el-form-item prop="c_short_name_en" :label="$t('1892')">
                <el-input v-model="staffData.c_short_name_en"></el-input>
              </el-form-item>
              <!-- 英语标识 -->
              <el-form-item prop="en_language" :label="$t('1894')">
                <el-input v-model="staffData.en_language"></el-input>
              </el-form-item>
              <!-- 企业电话 -->
              <el-form-item prop="c_mobile" :label="$t('1905')">
                <el-input v-model="staffData.c_mobile"></el-input>
              </el-form-item>
              <!-- 企业官网 -->
              <el-form-item prop="c_site" :label="$t('1906')">
                <el-input v-model="staffData.c_site"></el-input>
              </el-form-item>
              <!-- 联系邮箱 -->
              <el-form-item prop="email" :label="$t('1902')">
                <el-input v-model="staffData.email"></el-input>
              </el-form-item>
              <!-- 联系电话 -->
              <el-form-item prop="mobile" :label="$t('phone_number')">
                <el-input v-model="staffData.mobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-button size="small" type="primary" @click="saveStaff" v-if="$p('menu.certificate.mould.edit')">{{
              $t('67')
            }}</el-button>
            <el-button size="small" @click="staffPreview">{{ $t('217') }}</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 预览 -->
    <preview :content="form" :staffData="staffData" ref="pre" />
  </div>
</template>

<script>
import {
  getCertificateConfig, // 模板配置—获取证明模板配置
  saveBasicCertificateConfig, // 模板配置—保存通用模板配置
  saveOfficialCertificateConfig, // 模板配置—保存官方文件配置
  saveCertificateConfig // 模板配置—保存员工模板配置
} from 'api/payroll/prove-download'
import './staff-template/tem.scss'
import { viewUrlFn } from 'api/org/per'
import staffSearch from '_c/staff-search'
import upload from '_c/uploadAvatar'
import rdiff from 'recursive-diff'
import Preview from './preview'
export default {
  components: { upload, staffSearch, Preview },
  data() {
    return {
      activeName: 'currency',
      fileFormat: ['.png', '.jpg', '.jpeg'], // 上传限制
      form: {
        name: '',
        staff_name_en: '',
        staff_name_th: '',
        job: '',
        name_ceo: '',
        staff_name_en_ceo: '',
        staff_name_th_ceo: '',
        job_ceo: ''
      },
      currencyData: {
        company_logo: '',
        c_name_th: '',
        c_sign: '',
        address: '',
        address_en: ''
      },
      wCurrencyData: {},
      officialData: {
        trustee_sign: '',
        trustee_staff_id: ''
      },
      staffData: {
        is_apply: '', // 是否允许员工App申请
        c_name_en: '', // 企业名称英
        staff_formal: [], // 可申请员工各类型
        send_language: [], // 发送文件语言
        c_short_name_th: '', // 企业简称泰
        c_short_name_en: '', // 企业简称英
        th_language: '', // 泰语标识
        en_language: '', // 英语标识
        date_format: '', // 日期格式
        sign_staff_id: '', // 签字人员工ID
        c_mobile: '', // 企业电话
        c_site: '', // 企业官网
        sign: '', // 负责人电子签名
        mobile: '', // 联系电话
        email: '' // 联系邮箱
      },
      currencyRules: {
        c_name_th: [{ required: true, message: this.$t('1256'), trigger: 'blur' }] // 企业名称（泰）
      },
      officialRules: {
        trustee_staff_id: [{ required: true, message: this.$t('1256'), trigger: ['blur', 'change'] }]
      },
      staffRules: {
        is_apply: [{ required: true, message: this.$t('221'), trigger: 'change' }],
        staff_formal: [{ required: true, message: this.$t('221'), trigger: 'change' }],
        send_language: [{ required: true, message: this.$t('221'), trigger: 'change' }],
        date_format: [{ required: true, message: this.$t('1256'), trigger: 'change' }],
        c_mobile: [{ required: true, message: this.$t('1256'), trigger: 'blur' }],
        sign_staff_id: [{ required: true, message: this.$t('1256'), trigger: 'change' }],
        email: [{ required: true, message: this.$t('1256'), trigger: 'blur' }],
        c_name_en: [{ required: true, message: this.$t('1256'), trigger: 'blur' }],
        mobile: [{ required: true, message: this.$t('1256'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init(statu) {
      const res = await getCertificateConfig()
      if (!res) return
      if (statu === 'currency' || !statu) this.handleData(this.currencyData, res.data)
      if (statu === 'official' || !statu) {
        this.trusteeStaff({ staff_id: res.data.trustee_staff_id })
        this.handleData(this.officialData, res.data)
      }
      if (statu === 'staff' || !statu) {
        this.staffChange({ staff_id: res.data.sign_staff_id })
        this.handleData(this.staffData, res.data)
      }
      this.wCurrencyData = JSON.parse(JSON.stringify(this.currencyData))
      this.$nextTick(() => {
        this.sendLanguage()
        this.handleApply()
      })
      this.form = Object.assign({}, this.form, this.staffData, this.currencyData, this.officialData)
    },
    handleData(data, res) {
      const keys = Object.keys(data)
      keys.forEach(key => {
        data[key] = res[key] || data[key]
      })
    },
    handleApply() {
      this.staffRules.staff_formal[0].required = true
      if (this.staffData.is_apply === '2') {
        if (this.$refs.staffFormal) this.$refs.staffFormal.clearValidate()
        this.staffRules.staff_formal[0].required = false
      }
    },
    trusteeStaff(val) {
      this.officialData.trustee_staff_id = val.staff_id
      this.viewUrlFn(
        { staff_id: val.staff_id },
        'trusteeStaff',
        'job_ceo',
        'name_ceo',
        'staff_name_en_ceo',
        'staff_name_th_ceo'
      )
    },
    // 选人
    staffChange(val) {
      this.staffData.sign_staff_id = val.staff_id
      this.viewUrlFn({ staff_id: val.staff_id }, 'staffSearch', 'job', 'name', 'staff_name_en', 'staff_name_th')
    },
    async viewUrlFn(val, staff, job, name, staff_name_en, staff_name_th) {
      const res = await viewUrlFn(val)
      this.form[job] = res.data?.job_title_name
      this.form[name] = res.data?.staff_name
      this.form[staff_name_en] = res.data?.staff_name_en
      this.form[staff_name_th] = res.data?.staff_name_th
      const supervisorInfo = {
        avatar_url: res.data.avatar_url,
        mobile: res.data.mobile,
        staff_code: res.data.staff_code,
        staff_id: res.data.staff_id,
        staff_name: res.data.staff_name,
        staff_name_en: res.data.staff_name_en,
        staff_name_secondary: res.data.staff_name_secondary,
        staff_name_th: res.data.staff_name_th
      }
      if (this.$refs[staff]) {
        this.$refs[staff].res = supervisorInfo
        this.$refs[staff].supOptions = [supervisorInfo].filter(v => v.staff_name)
      }
    },
    handleClick() {
      this.$refs.config.scrollTop = this.$refs[this.activeName + 'Form'].$el.offsetTop - 64
    },
    handleScroll() {
      const config = this.$refs.config.scrollTop
      // const currencyForm = this.$refs.currencyForm.$el.offsetTop - 64 // -12
      const officialForm = this.$refs.officialForm.$el.offsetTop - 64 // 420
      const staffForm = this.$refs.staffForm.$el.offsetTop - 64 // 753
      if (config < officialForm) {
        this.activeName = 'currency'
      } else if (config >= staffForm) {
        this.activeName = 'staff'
      } else {
        this.activeName = 'official'
      }
    },
    saveCurrency() {
      // 保存通用配置
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          saveBasicCertificateConfig({
            c_name_th: this.currencyData.c_name_th,
            company_logo: this.currencyData.company_logo,
            c_sign: this.currencyData.c_sign
          }).then(res => {
            this.$message.success(res.message)
            this.init('currency')
          })
        }
      })
    },
    saveOfficial() {
      // 保存官方文件
      const diff = rdiff.getDiff(this.currencyData, this.wCurrencyData)
      if (diff.length) {
        this.$message.error(this.$t('certificate_module_6'))
        return
      }
      this.$refs.officialForm.validate(valid => {
        if (valid) {
          saveOfficialCertificateConfig(this.officialData).then(res => {
            this.$message.success(res.message)
            this.init('official')
          })
        }
      })
    },
    saveStaff() {
      const diff = rdiff.getDiff(this.currencyData, this.wCurrencyData)
      if (diff.length) {
        this.$message.error(this.$t('certificate_module_6'))
        return
      }
      this.$refs.staffForm.validate(valid => {
        if (valid) {
          saveCertificateConfig(this.staffData).then(res => {
            this.$message.success(res.message)
            this.init('staff')
          })
        }
      })
    },
    // 预览
    staffPreview() {
      this.$refs.staffForm.validate(valid => {
        if (valid) {
          this.$refs.pre.visible = true
        }
      })
    },
    sendLanguage() {
      this.staffRules.c_name_en[0].required = true
      if (!this.staffData.send_language.includes('en')) {
        if (this.$refs.nameEn) this.$refs.nameEn.clearValidate()
        this.staffRules.c_name_en[0].required = false
      }
    },
    handleClose(data, bindValue) {
      data[bindValue] = ''
    },
    uploadSuccess(val, data, bindValue) {
      data[bindValue] = val ? val.object_url : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  position: relative;
  &-content {
    background: #fff;
    padding: 62px 24px 0;
    overflow: hidden;
  }
  .tabs {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    /deep/ .el-tabs__header {
      .el-tabs__nav-scroll {
        padding: 0 24px;
      }
      .el-tabs__nav {
        line-height: 48px;
        height: 48px;
      }
    }
  }
  .config {
    height: calc(100% - 24px);
    overflow-y: auto;
    h2 {
      margin: 0 0 16px;
      width: 100%;
      height: 32px;
      line-height: 32px;
      background: #f0f2f5;
      font-size: 14px;
      color: #262626;
      font-weight: 400;
      padding-left: 16px;
    }
    .el-form {
      padding-bottom: 32px;
    }
    /deep/ .el-form-item {
      .el-form-item__label {
        width: 100%;
        text-align: left;
        padding-left: 12px;
        float: none;
        &::before {
          left: -0;
        }
      }
      .el-input {
        max-width: 90%;
        width: 90%;
      }
      .el-select {
        width: 100%;
      }
    }
    .baseinfo-wrap {
      overflow: auto;
      position: relative;
      padding-left: 10px;
    }
  }
}
.baseinfo-logo {
  width: 100px;
  height: 100px;
  background: $menuText;
  border-radius: 4px;
  padding: 0;
  overflow: hidden;
  position: relative;
  float: left;
  cursor: pointer;
  /deep/ .el-form-item__content {
    width: 100px;
    height: 100px;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .img {
    width: 100px;
    height: 100px;
    background: #d8d8d8;
    padding-top: 38px;
    padding-left: 38px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  &:hover {
    .close {
      opacity: 1;
    }
    .bottom-tip {
      opacity: 1;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  /deep/ .el-upload {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100px;
    height: 26px;
    background: transparent;
    opacity: 0;
    transition: all 0.3s;
    z-index: 10;
    .el-icon-plus {
      opacity: 0;
    }
  }
  > img {
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    transition: all 0.3s;
    opacity: 0.8;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.36);
    color: #fff;
    border-radius: 50%;
    opacity: 0;
  }
  .bottom-tip {
    position: absolute;
    transition: all 0.3s;
    height: 26px;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 26px;
    font-size: 12px;
    text-align: center;
    font-weight: 400;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.36);
    opacity: 0;
  }
}
.baseinfo-name {
  display: inline-block;
  width: calc(90% - 100px);
  padding: 33px 0 0 16px;
  font-weight: 400;
  font-size: 12px;
  color: #8c8c8c;
  .label-name {
    line-height: 20px;
  }
}
</style>
